import {
  Component,
  Input,
  Output,
  OnChanges,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  TemplateRef,
  Renderer2,
  OnDestroy,
  HostListener,
} from "@angular/core";
import {
  CampaignsService,
  JobOffersService,
  EventsService,
  PollsService,
  CandidatesService,
  PagerService,
  CommonService,
  SessionService,
  ClevertapEventsService,
  TalentPoolListEntity,
} from "../../services";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { WebinarsService } from "app/services/webinars.service";
import { DigitalCareerDaysService } from "app/services/digital-career-days.service";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap";
import { LocalStorageHelpers } from "app/helpers";
import { FeatureFlagService } from "app/services/feature-flag.service";
import { AppService } from "app/services/app.service";
import { environment } from "environments/environment";

@Component({
  selector: "app-paged-table",
  templateUrl: "./app-paged-table.component.html",
  styleUrls: ["./app-paged-table.component.scss"],
  providers: [
    // JobOffersService,
    EventsService,
    PollsService,
    CampaignsService,
    // CandidatesService,
    PagerService,
    CommonService,
    SessionService,
    WebinarsService,
  ],
})
export class AppPagedTableComponent implements OnChanges, OnDestroy {
  @Input() tablehead: Array<string>;
  @Input() type: string;
  @Input() filters: object;
  @Input() isAsync: boolean;
  @Input() items: any[] = null;
  @Input() destinationUrl: string = null;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCopy: EventEmitter<number> = new EventEmitter<number>();

  private data: any = [];
  public numberPage: Array<number> = [];
  public currentPage = 1;
  private limitPage = 10;
  public total: number;
  private allItems = [];
  public loading = false;
  public noResults = false;
  public noResultsLabel = "No results";
  public setup;
  public selectedCandidate = null;
  public jboxEnabled = this.ffs.isEnabled("pbox") || false;

  pager: any = {};
  pagedItems: any[];

  @ViewChild("detailCurriculum") public templateRef: TemplateRef<any>;
  modalRef: BsModalRef;
  curriculaId: any;
  curriculum: any;
  public openedFromUrlQP = false;
  public previousId = null;
  public nextId = null;
  private employersId = null;
  private scrollY: number;
  public totalPages: number;

  get currPage() {
    return this.currentPage - 1;
  }

  private msos;
  private msoh;

  constructor(
    private jobOfferService: JobOffersService,
    private eventsService: EventsService,
    private pollService: PollsService,
    private campaignService: CampaignsService,
    private candidatesService: CandidatesService,
    private pagerService: PagerService,
    private commonService: CommonService,
    private sessionService: SessionService,
    private webinarsService: WebinarsService,
    private careerDayService: DigitalCareerDaysService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageHelper: LocalStorageHelpers,
    private modalService: BsModalService,
    private renderer: Renderer2,
    private ffs: FeatureFlagService,
    private appService: AppService
  ) {
    // this.scrollTop();
    try {
      const tmp = JSON.parse(this.localStorageHelper.get("userData"));
      this.employersId = tmp.Teams[0]["employers_id"];
    } catch (e) {
      this.employersId = null;
    }

    this.msoh = this.modalService.onHide.subscribe(() => {
      // console.log('this.modalService.onHide.subscribe');
      this.setup(this.currentPage);
      window.scrollTo(0, this.scrollY);
      this.renderer.removeClass(document.body, "no-scroll");
      // FIX-ME
      this.updateUrlQueryParams();
      this.openedFromUrlQP = false;
    });

    this.msos = this.modalService.onShown.subscribe(() => {
      // console.log('this.modalService.onShown.subscribe');
      window.scrollTo(0, this.scrollY);
      this.renderer.addClass(document.body, "no-scroll");
    });

    this.ffs.unleash.on("update", () => {
      if (this.ffs.isEnabled('pbox') !== this.jboxEnabled) {
        this.jboxEnabled = this.ffs.isEnabled('pbox');
      }
    });
  }

  openDetail(data) {
    this.selectedCandidate = data;
  }
  
  async forwardToPBox(id) {
    if (!id) {
      return;
    }

    // Open a blank popup synchronously to avoid browser popup blockers.
    const popup: Window | null = window.open("", "_blank");

    try {
      const tokenResp = await this.appService.createJBoxTokenV2(id).toPromise();
      console.log("token", tokenResp);

      let jboxUrl = environment.jboxUrl;
      if (window.location.hostname === "localhost") {
        jboxUrl = "http://localhost:3003";
      }

      console.log("environment.jboxUrl", jboxUrl);

      const finalUrl = `${jboxUrl}/auth/${tokenResp.token}`;
      console.log("finalUrl", finalUrl);
      const finalUrlV2 = `${jboxUrl}/magic-link/job-postings/${tokenResp.token}`;
      console.log("finalUrlV2", finalUrlV2);

      if (popup) {
        popup.location.href = finalUrlV2;
        popup.focus();
      } else {
        // Fallback: try to open the URL directly (may still be blocked)
        window.open(finalUrlV2, "_blank");
      }
    } catch (err) {
      // If there was an error, close the popup if it was opened.
      if (popup) {
        popup.close();
      }
      console.error("Unable to redirect to PBox:", err);
    }
  }


  ngOnChanges(event: SimpleChanges) {
    // console.log('changed', event);
    if (!event.filters || !event.filters.firstChange) {
      this.loading = true;
      this.noResults = false;
      this.pager = {};
      this.pagedItems = [];
      this.currentPage = 1;
      const storedPage = this.sessionService.get(this.type + "_paging");
      if (storedPage) {
        this.currentPage = storedPage;
      }
      this.setupByType();
    }

    console.log(event.items);
  }

  private setupByType() {
    let stored;
    switch (this.type) {
      case "webinars": {
        this.setup = this.setupWebinars;
        this.setupWebinars(this.currentPage);
        break;
      }
      case "digital-career-days": {
        this.setup = this.setupDigitalCareerDays;
        this.setupDigitalCareerDays(this.currentPage);
        break;
      }
      case "joboffers":
        this.setup = this.setupJobOffers;
        this.setupJobOffers(this.currentPage);
        break;
      case "events":
        this.setup = this.setupEvents;
        this.setupEvents(this.currentPage);
        break;
      case "polls":
        this.setup = this.setupPolls;
        stored = this.sessionService.get("polls");
        if (stored) {
          this.setupPolls(stored);
        }
        this.campaignService.getAllPolls().subscribe((polls) => {
          this.sessionService.set("polls", polls);
          this.setupPolls(polls);
        });
        break;
      case "articles":
        this.setup = this.setupArticles;
        stored = this.sessionService.get("articles");
        if (stored) {
          this.setupArticles(stored);
        }
        this.campaignService.getAllArticles().subscribe((articles) => {
          this.sessionService.set("articles", articles);
          this.setupArticles(articles);
        });
        break;
      case "candidates":
        this.currentPage = 1;
        this.setup = this.setupTalentPool;
        this.noResultsLabel =
          "You don't have any candidates yet or you are not collecting cv, " +
          "post a job without external link to create your own database of cv";
        this.setupTalentPool(this.currentPage);
        break;
      case "curricula-joboffer":
        this.currentPage = 1;
        this.setup = this.setupCandidates;
        this.noResultsLabel =
          "You don't have any candidates yet or you are not collecting cv, " +
          "post a job without external link to create your own database of cv";
        this.setupCandidates(this.currentPage);
        break;
    }
  }

  private setupPolls(polls) {
    // console.log('polls', polls);
    for (let i = 0; i < polls.length; i++) {
      const formattedPoll = {
        answer1: "",
        answer2: "",
        total1: 0,
        total2: 0,
        total: 0,
      };
      const post = polls[i]["Post"];
      if (post) {
        // console.log('post', post);
        formattedPoll.answer1 = post["Answers"][0]
          ? post["Answers"][0]["answer"]
          : "";
        formattedPoll.answer2 = post["Answers"][1]
          ? post["Answers"][1]["answer"]
          : "";
        for (let j = 0; j < post["UserAnswers"].length; j++) {
          if (post["UserAnswers"][j]["answers_id"] === post["Answers"][0].id) {
            formattedPoll.total1++;
          }
          if (post["UserAnswers"][j]["answers_id"] === post["Answers"][1].id) {
            formattedPoll.total2++;
          }
        }
        formattedPoll["total"] = formattedPoll.total1 + formattedPoll.total2;
        formattedPoll["percentage1"] = Math.round(
          (formattedPoll.total1 / formattedPoll.total) * 100
        );
        formattedPoll["percentage2"] = Math.round(
          (formattedPoll.total2 / formattedPoll.total) * 100
        );
      }
      // delete polls[i]['Post'];
      polls[i]["Post"]["Answers"] = formattedPoll;
    }
    this.allItems = polls;
    console.log("this.allItems", this.allItems);
    const stored_page = this.sessionService.get(this.type + "_paging");
    if (stored_page) {
      this.setupTableElement(stored_page);
      this.setPage(stored_page);
    } else {
      this.setupTableElement(1);
      this.setPage(1);
    }
  }

  private setupArticles(articles) {
    this.allItems = articles;
    const stored_page = this.sessionService.get(this.type + "_paging");
    if (stored_page) {
      this.setupTableElement(stored_page);
      this.setPage(stored_page);
    } else {
      this.setupTableElement(1);
      this.setPage(1);
    }
  }

  private async setupCandidates(page) {
    this.loading = true;
    console.log(this.filters);

    let sanitizedFilters = JSON.parse(JSON.stringify(this.filters));
    if (sanitizedFilters["job_offers_id"]) {
      sanitizedFilters["job_offers_id"] =
        sanitizedFilters["job_offers_id"].value;
    }
    if (sanitizedFilters["languages_id"]) {
      sanitizedFilters["languages_id"] = Number(
        sanitizedFilters["languages_id"].value
      );
    }
    if (sanitizedFilters["language_level"]) {
      sanitizedFilters["language_level"] = Number(
        sanitizedFilters["language_level"].value
      );
    }
    if (sanitizedFilters["cities_ids"] && sanitizedFilters["cities_ids"][0]) {
      sanitizedFilters["cities_ids"][0] = sanitizedFilters["cities_ids"][0].id;
    }
    if (
      sanitizedFilters["universities_ids"] &&
      sanitizedFilters["universities_ids"][0]
    ) {
      sanitizedFilters["universities_ids"][0] =
        sanitizedFilters["universities_ids"][0].id;
    }
    if (
      sanitizedFilters["faculty_tags"] &&
      sanitizedFilters["faculty_tags"][0]
    ) {
      sanitizedFilters["faculty_tags"][0] =
        sanitizedFilters["faculty_tags"][0].id;
    }
    if (sanitizedFilters["tags_ids"] && sanitizedFilters["tags_ids"][0]) {
      sanitizedFilters["tags_ids"][0] = sanitizedFilters["tags_ids"][0].id;
    } else {
      delete sanitizedFilters["tags_ids"];
    }
    if (sanitizedFilters["skills_ids"] && sanitizedFilters["skills_ids"][0]) {
      sanitizedFilters["skills_ids"][0] = sanitizedFilters["skills_ids"][0].id;
    }

    console.log(sanitizedFilters);
    const candidates = await this.candidatesService
      .getAll(sanitizedFilters, page - 1)
      .toPromise();
    // console.log('candidates', candidates);
    this.notify.emit(candidates);
    this.total = candidates["total"];
    this.pagedItems = candidates["rows"];
    this.totalPages = Math.ceil(this.total / 20);
    this.asyncSetupTableElement(page);
    this.asyncSetPage(page);
  }

  private async setupTalentPool(page) {
    this.loading = true;
    console.log(this.filters);

    let sanitizedFilters = JSON.parse(JSON.stringify(this.filters));
    if (sanitizedFilters["job_offers_id"]) {
      sanitizedFilters["job_offers_id"] =
        sanitizedFilters["job_offers_id"].value;
    }
    if (sanitizedFilters["languages_id"]) {
      sanitizedFilters["languages_id"] = Number(
        sanitizedFilters["languages_id"].value
      );
    }
    if (sanitizedFilters["language_level"]) {
      sanitizedFilters["language_level"] = Number(
        sanitizedFilters["language_level"].value
      );
    }
    if (sanitizedFilters["cities_ids"] && sanitizedFilters["cities_ids"][0]) {
      sanitizedFilters["cities_ids"][0] = sanitizedFilters["cities_ids"][0].id;
    }
    if (
      sanitizedFilters["institutes_ids"] &&
      sanitizedFilters["institutes_ids"][0]
    ) {
      sanitizedFilters["institutes_ids"][0] =
        sanitizedFilters["institutes_ids"][0].id;
    }
    if (
      sanitizedFilters["faculty_tags"] &&
      sanitizedFilters["faculty_tags"][0]
    ) {
      sanitizedFilters["faculty_tags"][0] =
        sanitizedFilters["faculty_tags"][0].id;
    }
    if (sanitizedFilters["tags_ids"] && sanitizedFilters["tags_ids"][0]) {
      // sanitizedFilters["tags_ids"][0] = sanitizedFilters["tags_ids"][0].id;
      sanitizedFilters["tags"] = [sanitizedFilters["tags_ids"][0].name];
      delete sanitizedFilters["tags_ids"];
    } else {
      delete sanitizedFilters["tags_ids"];
    }
    if (sanitizedFilters["skills_ids"] && sanitizedFilters["skills_ids"][0]) {
      sanitizedFilters["skills_ids"][0] = sanitizedFilters["skills_ids"][0].id;
    }

    if (sanitizedFilters["study_tags_ids"] && sanitizedFilters["study_tags_ids"][0]) {
      sanitizedFilters["study_tags_ids"][0] = sanitizedFilters["study_tags_ids"][0].id;
    }

    if (sanitizedFilters["geolocations_ids"] && sanitizedFilters["geolocations_ids"][0]) {
      sanitizedFilters["geolocations_ids"][0] = String(sanitizedFilters["geolocations_ids"][0].id);
    }

    if (sanitizedFilters['user_status'] && sanitizedFilters['user_status'] !== 'all') {
      sanitizedFilters['user_status'] = [sanitizedFilters['user_status']]
    } else {
      delete sanitizedFilters['user_status'];
    }

    delete sanitizedFilters['status'];

    console.log(sanitizedFilters);
    const candidates = await this.candidatesService
      .getTalentPool(sanitizedFilters, page - 1, 20)
      .toPromise();
    
    // console.log('candidates', candidates);
    this.notify.emit(candidates);
    this.total = candidates["total"];
    this.pagedItems = candidates["list"] as TalentPoolListEntity[];
    this.pagedItems.forEach(c => c.other_applications = c.other_applications.reverse())
    this.totalPages = Math.ceil(this.total / 20);
    this.selectedCandidate = this.pagedItems[0];
    this.asyncSetupTableElement(page);
    this.asyncSetPage(page, 20);
  }

  private setupWebinars(page) {
    this.loading = true;
    // FIX-ME
    // change below service
    if (this.items && this.items !== null) {
      if (this.items.length === 0) {
        this.noResultsLabel = "Currently there are no active experiences";
      }
      this.notify.emit(this.items);
      // FIX-ME need to check with Simone
      this.total = this.items.length;
      this.pagedItems = this.items;
      this.asyncSetupTableElement(page);
      this.asyncSetPage(page);
    } else {
      this.webinarsService.getAll(page - 1).subscribe((webinars) => {
        if (webinars.count === 0) {
          this.noResultsLabel = "Currently there are no active experiences";
        }
        this.notify.emit(webinars);
        // FIX-ME need to check with Simone
        this.total = webinars.count;
        this.pagedItems = webinars.rows;
        this.asyncSetupTableElement(page);
        this.asyncSetPage(page);
      });
    }
  }

  private setupDigitalCareerDays(page) {
    this.loading = true;
    // FIX-ME
    // change below service
    this.careerDayService.getAll(page - 1).subscribe((result) => {
      if (result.length === 0) {
        // this.noResultsLabel = 'Currently there are no active webinar';
      }
      // FIX-ME check code below before uncomment
      // let _new;
      // for (let i = jobOffers['rows'].length - 1; i >= 0; i--) {
      //   _new = 0;
      //   if (jobOffers['rows'][i]['UserJobs'] && jobOffers['rows'][i]['UserJobs'].length) {
      //     for (let k = jobOffers['rows'][i]['UserJobs'].length - 1; k >= 0; k--) {
      //       if (!jobOffers['rows'][i]['UserJobs'][k]['viewed']) {
      //         _new++;
      //       }
      //     }
      //     jobOffers['rows'][i]['new_applications'] = _new;
      //   }
      // }

      this.notify.emit(result);
      // FIX-ME need to check with Simone
      this.total = result.length;
      this.pagedItems = result;
      this.asyncSetupTableElement(page);
      this.asyncSetPage(page);
    });
  }

  private setupJobOffers(page) {
    this.loading = true;
    if (this.items && this.items !== null) {
      if (this.items.length === 0) {
        this.noResultsLabel = "Currently there are no active job offers";
      }

      let _new;
      for (let i = this.items.length - 1; i >= 0; i--) {
        _new = 0;
        if (this.items[i]["UserJobs"] && this.items[i]["UserJobs"].length > 0) {
          for (let k = this.items[i]["UserJobs"].length - 1; k >= 0; k--) {
            if (!this.items[i]["UserJobs"][k]["viewed"]) {
              _new++;
            }
          }
          this.items[i]["new_applications"] = _new;
        }
      }

      this.notify.emit(this.items);
      this.total = this.items.length;
      this.pagedItems = this.items;
      this.asyncSetupTableElement(page);
      this.asyncSetPage(page);
    } else {
      const obs = this.jobOfferService.getJobsV3(page - 1);

      obs.subscribe((jobOffers) => {
        if (jobOffers["count"] === 0) {
          this.noResultsLabel = "Currently there are no active job offers";
        }
        let _new;
        for (let i = jobOffers["rows"].length - 1; i >= 0; i--) {
          _new = 0;
          if (
            jobOffers["rows"][i]["UserJobs"] &&
            jobOffers["rows"][i]["UserJobs"].length
          ) {
            for (
              let k = jobOffers["rows"][i]["UserJobs"].length - 1;
              k >= 0;
              k--
            ) {
              if (!jobOffers["rows"][i]["UserJobs"][k]["viewed"]) {
                _new++;
              }
            }
            jobOffers["rows"][i]["new_applications"] = _new;
          }
        }

        this.notify.emit(jobOffers);
        this.total = jobOffers["count"];
        this.pagedItems = jobOffers["rows"];
        this.asyncSetupTableElement(page);
        this.asyncSetPage(page);
      });
    }
  }

  private setupEvents(page) {
    this.loading = true;
    this.eventsService.getAll(page - 1).subscribe((events) => {
      if (events["total"] === 0) {
        this.noResultsLabel = "Currently there are no active events";
      }
      let _new;
      for (let i = events["rows"].length - 1; i >= 0; i--) {
        _new = 0;
        if (
          events["rows"][i]["UserJobs"] &&
          events["rows"][i]["UserJobs"].length
        ) {
          for (let k = events["rows"][i]["UserJobs"].length - 1; k >= 0; k--) {
            if (!events["rows"][i]["UserJobs"][k]["viewed"]) {
              _new++;
            }
          }
          events["rows"][i]["new_applications"] = _new;
        }
      }

      this.notify.emit(events);
      this.total = events["total"];
      this.pagedItems = events["rows"];
      this.asyncSetupTableElement(page);
      this.asyncSetPage(page);
    });
  }

  setPage(page: number) {
    this.loading = false;
    this.noResults = this.allItems.length === 0;
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // Store paging to session
    this.sessionService.set(this.type + "_paging", page);
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page);
    // get current page of items
    this.pagedItems = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  private asyncSetPage(page: number, limit = 10) {
    this.loading = false;
    this.noResults = this.total === 0;
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    this.sessionService.set(this.type + "_paging", page);
    this.pager = this.pagerService.getPager(this.total, page, limit);
  }

  public asyncSetupTableElement(page: number) {
    this.currentPage = page;
    const start = (page - 1) * this.limitPage;
    const stop = page * this.limitPage;
    this.data = [];
    this.pagedItems.forEach((value, index) => {
      if (index >= start && index < stop) {
        this.data.push(value);
      }
    });
  }

  public setupTableElement(page: number) {
    // console.log('page', page);
    this.currentPage = page;
    const start = (page - 1) * this.limitPage;
    const stop = page * this.limitPage;
    this.data = [];
    this.allItems.forEach((value, index) => {
      if (index >= start && index < stop) {
        this.data.push(value);
      }
    });
  }

  public isFinished(date) {
    return moment().diff(date) > 0;
  }

  private updateUrlQueryParams(value: string = null, key = "cvId"): void {
    return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { [key]: value },
      queryParamsHandling: "merge",
    });
  }

  goToPrevious(id: any) {
    // this.openModal(null, null, id, null, this.curricula.filter(c => c['User']['id'] === id)[0]);
    this.curriculaId = id;
    ClevertapEventsService.emitEvent("openedCv", {
      employers_id: this.employersId,
    });
    // this.previousId = this.curricula[index - 1] ? this.curricula[index - 1]['User']['id'] : null;
    // this.nextId = this.curricula[index + 1] ? this.curricula[index + 1]['User']['id'] : null;
    const current = this.pagedItems.filter((c) => c["User"]["id"] === id)[0];
    this.curriculum = current;
    const currentPosition = this.pagedItems.indexOf(current);

    this.previousId = this.pagedItems[currentPosition - 1]
      ? this.pagedItems[currentPosition - 1]["User"]["id"]
      : null;
    this.nextId = this.pagedItems[currentPosition + 1]
      ? this.pagedItems[currentPosition + 1]["User"]["id"]
      : null;

    this.updateUrlQueryParams(this.curriculaId);
  }

  goToNext(id: any) {
    // this.openModal(null, null, id, null, this.curricula.filter(c => c['User']['id'] === id)[0]);
    this.curriculaId = id;
    ClevertapEventsService.emitEvent("openedCv", {
      employers_id: this.employersId,
    });
    const current = this.pagedItems.filter((c) => c["User"]["id"] === id)[0];
    this.curriculum = current;
    const currentPosition = this.pagedItems.indexOf(current);

    this.previousId = this.pagedItems[currentPosition - 1]
      ? this.pagedItems[currentPosition - 1]["User"]["id"]
      : null;
    this.nextId = this.pagedItems[currentPosition + 1]
      ? this.pagedItems[currentPosition + 1]["User"]["id"]
      : null;

    this.updateUrlQueryParams(this.curriculaId);
  }

  goToPreviousPage($event) {
    this.setupCandidates($event).then(() => {
      const index = this.pagedItems.length - 1;
      this.curriculaId = this.pagedItems[index]["User"]["id"];
      this.curriculum = this.pagedItems[index];
      ClevertapEventsService.emitEvent("openedCv", {
        employers_id: this.employersId,
      });
      this.previousId = this.pagedItems[index - 1]
        ? this.pagedItems[index - 1]["User"]["id"]
        : null;
      this.nextId = index;

      this.updateUrlQueryParams(this.curriculaId);
    });
  }

  goToNextPage($event) {
    this.setupCandidates($event).then(() => {
      const index = 0;
      this.curriculaId = this.pagedItems[index]["User"]["id"];
      this.curriculum = this.pagedItems[index];
      ClevertapEventsService.emitEvent("openedCv", {
        employers_id: this.employersId,
      });
      this.previousId = null;
      this.nextId = this.pagedItems[index + 1]
        ? this.pagedItems[index + 1]["User"]["id"]
        : null;

      this.updateUrlQueryParams(this.curriculaId);
    });
  }

  openModal(
    $event: Event,
    _template: TemplateRef<any>,
    userId: any,
    jobId: any,
    curriculum: any,
    index: any
  ) {
    this.scrollY = window.scrollY;

    if ($event && $event.target) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
      $event.stopPropagation();
    }

    // this.curricula.forEach(c => c['toggled'] = false);
    // if (curriculum && curriculum['toggled']) {
    //   curriculum['toggled'] = !curriculum['toggled']
    // } else {
    //   curriculum['toggled'] = true;
    // }

    // if (this.external) {
    //   return;
    // }

    this.modalRef = this.modalService.show(_template, {
      class: "modal-big",
      animated: false,
    } as ModalOptions);
    this.curriculaId = userId;

    ClevertapEventsService.emitEvent("openedCv", {
      employers_id: this.employersId,
    });

    if (index !== null) {
      this.previousId = this.pagedItems[index - 1]
        ? this.pagedItems[index - 1]["User"]["id"]
        : null;
      this.nextId = this.pagedItems[index + 1]
        ? this.pagedItems[index + 1]["User"]["id"]
        : null;
    }

    this.updateUrlQueryParams(this.curriculaId);

    // tslint:disable-next-line
    // const e = document.getElementsByClassName('accordion-' + userId)[0] as any;
    // e.focus();
    // setTimeout(() => {
    //   window.scrollTo(0, this.scrollY)
    // }, 250);
  }

  ngOnDestroy() {
    if (this.msoh) {
      this.msoh.unsubscribe();
    }
    if (this.msos) {
      this.msos.unsubscribe();
    }
  }

  ngAfterViewInit() {
    // FIX-ME
    // if cvId is present in url qp
    if (this.route.snapshot.queryParams.cvId) {
      setTimeout(() => {
        this.openedFromUrlQP = true;
        this.openModal(
          null,
          this.templateRef,
          this.route.snapshot.queryParams.cvId,
          null,
          null,
          null
        );
      });
    }
  }

  view(id, index?) {
    let url = "";
    switch (this.type) {
      case "digital-career-days": {
        url = "/career_days/";
        break;
      }
      case "webinars": {
        url = "/experiences/";
        break;
      }
      case "joboffers":
        url = "/recruiting/";
        break;
      case "events":
        url = "/events/";
        break;
      case "articles":
        url = "/articles/";
        break;
      case "polls":
        url = "/polls/";
        break;
      case "candidates":
        url = "/recruiting/curricula/";
        break;
    }
    if (index) {
      this.pagedItems[index].viewed = true;
    }
    if (this.destinationUrl) {
      url = this.destinationUrl;
    }

    if (this.type === "candidates") {
      this.openModal(id, this.templateRef, id, null, this.curriculum, index);
    } else {
      this.router.navigate([url, id]);
    }
  }

  // (id dell'utente)
  public setViewed(users_id) {
    this.commonService.setEmployersUsersViewed(users_id).subscribe((res) => {
      console.log("Set viewed", res);
    });
  }

  public isNew(candidate) {
    for (const i in candidate.JobOffers) {
      if (candidate.JobOffers[i].UserJob.viewed) {
        return false;
      }
    }
    return true;
  }

  public isImgFromFb(img) {
    return this.commonService.isImgFromFb(img);
  }

  public scrollTop() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    });
  }

  /*
  @HostListener("window:click", ["$event"])
  onClick($event) {
    console.log($event.srcElement.id);
    const container: HTMLDivElement =
      document.querySelector(".curricula-wrapper");
    console.log("Container", container);
    if ($event.srcElement.classList.contains("dd")) {
      container.classList.remove("no-overflow");
      return;
    }
    // this.dropvisible = false;
    container.classList.add("no-overflow");
  }

  @HostListener("window:resize", ["$event"])
  onResize($event) {
    this.onWindowScroll();
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll(event?) {
    try {
      const scrollTop: any =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (document.documentElement ||
            document.body.parentNode ||
            document.body)["scrollTop"];
      const ele: HTMLElement = document.querySelector(".positioning");
      const leftCol: HTMLElement = document.querySelector(".scrolling");
      ele.style.width = leftCol.offsetWidth - 30 + "px";
      const c: HTMLElement = document.querySelector(".scrolling > * > div");
      const offsetHeifght = 500;
      // const filterEl = document.querySelector('border.p-2.mb-3.mt-2.rounded.collapse.in.show');
      const h = c.offsetHeight * this.pagedItems.length;
      const stop =
        (document.querySelector(".top-wrapper") as HTMLElement).offsetHeight ||
          !this.isCollapsed
          ? 450
          : 250;
      // // console.log(scrollTop, stop);
      if (h > offsetHeifght) {
        if (scrollTop >= stop) {
          ele.classList.add("fixed");
          // ele.style.top = '100px'
        } else {
          ele.classList.remove("fixed");
          // ele.style.top = '0';
        }
      } else {
        // ele.style.height = 'auto';
      }

      //
      if (document.querySelectorAll(".scrolling > *").length <= 2) {
        ele.classList.remove("fixed");
      }
    } catch (e) { }
  }
    */
}
